import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactFitText from 'react-fittext'


class Header extends Component {

  style() {
    return {
      width: `100%`,
      margin: 'auto',
      textAlign: 'center',
      top: '0',
      height: `${this.props.height}px`,
      // left: '50%',
      // transform: 'translateX(-50%)',
      display: 'inline-block',
      zIndex: '1',
      backgroundColor: 'black',
    }
  }

  // innerStyle() {
  //   return {
  //     width: '100%', height: '100%',
  //     padding: '0px',
  //     position: 'relative',
  //     margin: 'auto',
  //   }
  // }

  render() {
    return (
      <div style={this.style()}>
        <ReactFitText maxFontSize={(this.props.height*0.75) + 'px'}>
          <h1>
            Etta Allean
            </h1>

        </ReactFitText>
        </div>
    )
  }
}

const mapStateToProps = (state) => ({
  width: state.sizing.windowSize.width,
  height: state.sizing.headerHeight
})

export default connect(mapStateToProps, null)(Header)




// WEBPACK FOOTER //
// ./src/Header.js